const MAX_MONTHS = 48

function padMonth(value) {
  return String(value).padStart(2, '0')
}

function clampMonthCount(value, fallback) {
  const numericValue = Number(value)
  if (!Number.isFinite(numericValue)) {
    return fallback
  }
  return Math.min(MAX_MONTHS, Math.max(1, Math.floor(numericValue)))
}

function addMonths(month, offset) {
  const totalMonths = month.year * 12 + month.monthIndex + offset
  return {
    year: Math.floor(totalMonths / 12),
    monthIndex: totalMonths % 12,
  }
}

function formatMonthStart(month) {
  return `${month.year}-${padMonth(month.monthIndex + 1)}-01`
}

function formatMonthEnd(month) {
  const lastDay = new Date(Date.UTC(month.year, month.monthIndex + 1, 0)).getUTCDate()
  return `${month.year}-${padMonth(month.monthIndex + 1)}-${String(lastDay).padStart(2, '0')}`
}

export function buildVolumePeriodRange({
  months,
  fallbackMonths,
  includePreviousMonth = true,
  today = new Date(Date.now()),
}) {
  const monthCount = clampMonthCount(months, fallbackMonths)
  const currentMonth = {
    year: today.getUTCFullYear(),
    monthIndex: today.getUTCMonth(),
  }
  const previousMonth = addMonths(currentMonth, -1)
  const periodEnd = includePreviousMonth ? previousMonth : addMonths(previousMonth, -1)
  const periodStart = addMonths(periodEnd, -(monthCount - 1))

  return {
    start: formatMonthStart(periodStart),
    end: formatMonthEnd(periodEnd),
  }
}

export function formatVolumePeriodRange(periodRange) {
  return `${periodRange.start} - ${periodRange.end}`
}
